<template>
  <q-card flat>
    <q-card-section class="no-padding">

      <q-banner class="text-white bg-blue" inline-actions>
        فاکتور
        <q-badge align="top" color="indigo" class="q-ml-xs">{{ orderInfo.Factor_Num }}</q-badge>
        <q-badge align="top" label="برگشتی" v-if="orderInfo.Buy_Kind===-1" color="red" text-color="white" class="q-ml-xs" />
        <q-chip square label="مبلغ کل فاکتور" v-if="!noPrice">
          <q-badge color="green" text-color="white"
                   :label="(lodash.sumBy(OrderDetailsList, item => parseInt(item.SaleG_Tax)) + (lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count) * parseInt(item.SaleG_PricePure)))).toLocaleString()"/>
        </q-chip>
        <q-chip square label="کرایه بار" v-if="!noPrice">
          <q-badge color="green" text-color="white"
                   :label="(orderInfo.Buy_Transfer).toLocaleString()"/>
        </q-chip>
        <template v-slot:action>
          <q-btn icon="close" v-close-popup flat round v-if="!issueFactor"/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section v-if="orderInfo.ImmediatelySaleCustomer" class="no-padding text-center">
      <q-badge color="red" text-color="white" label="فروش فروشگاهی(فوری)" />
      <q-space/>
      <q-chip square class="no-padding" dense>
        <q-chip size="sm" v-if="orderInfo.ImmediatelySaleCustomer" :label="orderInfo.Cs_Name" square/>
        <q-chip size="sm" v-if="orderInfo.ImmediatelySaleCustomer" icon="arrow_back" square/>
        <q-chip size="sm" v-if="orderInfo.ImmediatelySaleCustomer"
                :label="orderInfo.ImmediatelySaleCustomerName" square/>
      </q-chip>
    </q-card-section>

    <q-card-section class="no-padding">
      <q-select v-model="selectedStoreId"
                :options="storeList"
                option-label="StorName"
                option-value="StorID"
                use-chips
                filled
                :rules="[requireRole]"
                v-if="orderInfo.Factor_Buy_State===0 && orderInfo.Buy_State===1"
                label="انتخاب انبار برای دریافت کالا"
      />
    </q-card-section>
    <q-card-section class="no-padding">
      <q-table
          :data="OrderDetailsList"
          row-key="Goods_ID"
          wrap-cells
          flat
          :hide-header="$q.screen.lt.md"
          :rows-per-page-options="[0]">
        <template v-slot:header>
          <q-tr class="text-bold">
            <td class="text-center">کد کالا</td>
            <td class="text-center">نام کالا</td>
            <td class="text-center">تعداد</td>
            <td class="text-center">واحد</td>
            <td class="text-center" v-if="!noPrice">قیمت واحد</td>
            <td class="text-center" v-if="!noPrice">قیمت کل</td>
            <td class="text-center" v-if="!noPrice">مالیات و ارزش افزوده</td>
            <td class="text-center" v-if="!noPrice">تخفیف</td>
          </q-tr>
          <q-tr class="bg-indigo text-white text-center">
            <td>{{ OrderDetailsList.length }} قلم</td>
            <td></td>
            <td>{{ lodash.sumBy(OrderDetailsList, "SaleG_Count") }}</td>
            <td></td>
            <td></td>
            <td v-if="!noPrice">
              {{
                (lodash.sumBy(OrderDetailsList, item => parseFloat(item.SaleG_Count) * parseInt(item.SaleG_PricePure))).toLocaleString()
              }}
            </td>
            <td v-if="!noPrice">{{
                lodash.sumBy(OrderDetailsList, item => parseInt(item.SaleG_Tax)).toLocaleString()
              }}
            </td>
            <td v-if="!noPrice">{{
                lodash.sumBy(OrderDetailsList, item => parseInt(item.SaleG_Off) * item.SaleG_Count).toLocaleString()
              }}
            </td>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr :props="props" class="my-class text-center" v-if="!$q.screen.lt.md">
            <td>
              <q-btn
                  @click="deleteItem(props.row)"
                  v-if="$store.state.roles.some(v=>['admin','can_delete_goods_from_buy_factor'].includes(v)) && !noPrice"
                  color="red-10" flat round icon="delete"/>
              <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                      v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                      :label="props.row.Goods_Code"/>
            </td>
            <td class="text-left">
              {{ props.row.Goods_Name }}
              <q-space/>
              <q-chip color="indigo" text-color="white" :label="props.row.Group_Name"/>
            </td>
            <td>
              <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991' && !issueFactor">
                {{ props.row.SaleG_Count }}
              </q-badge>
              <q-input clearable dir="ltr" v-model="props.row.SaleG_Count" v-if="issueFactor" filled/>
            </td>
            <td>
              <q-chip square color="brown" text-color="white" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991'">
                {{ props.row.Unit_Name }}
              </q-chip>
            </td>
            <td v-if="!noPrice">
              <q-field
                  v-if="issueFactor"
                  v-model="props.row.SaleG_PricePure"
                  mask="currency"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  filled
                  dense
                  clearable
                  lazy-rules
                  :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                         v-money="moneyFormatForDirective"
                         v-show="floatingLabel">
                </template>
              </q-field>
              <q-chip text-color="white" square color="teal" class="q-ml-xs" v-if="!issueFactor">
                {{ parseInt(props.row.SaleG_PricePure).toLocaleString() }}
                ریال
              </q-chip>
            </td>
            <td v-if="!noPrice">
              <q-chip text-color="white" square color="teal-14" class="q-ml-xs">
                {{ (props.row.SaleG_Count * props.row.SaleG_PricePure) | toLoalString }}
                ریال
              </q-chip>
            </td>
            <td class="text-center" v-if="!noPrice">
              <q-field
                  v-if="issueFactor"
                  v-model="props.row.SaleG_Tax"
                  mask="currency"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  filled
                  dense
                  clearable
                  lazy-rules
                  :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                         v-money="moneyFormatForDirective"
                         v-show="floatingLabel">
                </template>
                <template v-slot:append>
                  <q-btn icon="attach_money" flat round padding="none" @click="computeTax(props.row)">
                    <q-tooltip>
                      محاسبه مالیات
                    </q-tooltip>
                  </q-btn>
                </template>
              </q-field>
              <q-chip v-if="!issueFactor" text-color="white" square color="teal-14" class="q-ml-xs">
                {{ (props.row.SaleG_Tax) | toLoalString }}
                ریال
              </q-chip>
            </td>
            <td v-if="props.row.Goods_Code!=='109991' && !noPrice">
              <q-field
                  v-if="issueFactor"
                  v-model="props.row.SaleG_Off"
                  mask="currency"
                  label-color="indigo"
                  autofocus
                  dir="ltr"
                  filled
                  dense
                  clearable
                  lazy-rules
                  :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                  <input :id="id" class="q-field__native text-right" :value="value"
                         @change="e => emitValue(e.target.value.replaceAll(',',''))"
                         v-money="moneyFormatForDirective"
                         v-show="floatingLabel">
                </template>
              </q-field>
              <q-chip square color="red" v-if="!issueFactor" text-color="white"
                      :label="`${(parseInt(props.row.SaleG_Count) * parseInt(props.row.SaleG_Off)).toLocaleString()}`"/>
            </td>
          </q-tr>
          <q-tr :props="props" class="my-class" v-if="$q.screen.lt.md">
            <td>
              <q-card flat>
                <q-card-actions class="no-padding">
                  <q-btn
                      @click="deleteItem(props.row)"
                      v-if="$store.state.roles.some(v=>['admin','can_delete_goods_from_buy_factor'].includes(v)) && !noPrice"
                      color="red-10" flat round icon="delete"/>
                </q-card-actions>
                <q-card-section class="no-padding">
                  <q-chip clickable @click="showProductDetailsDialog(props.row)" square
                          v-if="props.row.Goods_Code!=='109991'" color="red" text-color="white"
                          :label="props.row.Goods_Code"/>
                  {{ props.row.Goods_Name }}
                  <q-badge color="indigo" class="q-ml-xs" v-if="props.row.Goods_Code!=='109991' && !issueFactor">
                    {{ props.row.SaleG_Count }}
                    ( {{ props.row.Unit_Name }})
                  </q-badge>
                  <q-input clearable dir="ltr" v-model="props.row.SaleG_Count" v-if="issueFactor" filled/>
                  <q-space/>
                  <q-chip color="indigo" text-color="white" dense :label="props.row.Group_Name"/>
                </q-card-section>
                <q-card-section class="no-padding" v-if="!noPrice">
                  <q-field
                      v-if="issueFactor"
                      v-model="props.row.SaleG_PricePure"
                      mask="currency"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      filled
                      dense
                      clearable
                      lazy-rules
                      :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value.replaceAll(',',''))"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>
                  </q-field>
                  <q-chip text-color="white" square color="teal" class="q-ml-xs" v-if="!issueFactor">
                    {{ parseInt(props.row.SaleG_PricePure).toLocaleString() }}
                    ریال
                  </q-chip>
                  <q-chip text-color="white" square color="teal" class="q-ml-xs" v-if="!issueFactor">
                    {{ (props.row.SaleG_Count * parseInt(props.row.SaleG_PricePure)).toLocaleString() }}
                    ریال
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding" v-if="!noPrice">
                  <span class="text-subtitle2">مالیات و ارزش افزوده</span>
                  <q-field
                      v-if="issueFactor"
                      v-model="props.row.SaleG_Tax"
                      mask="currency"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      filled
                      dense
                      clearable
                      lazy-rules
                      :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value.replaceAll(',',''))"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>
                    <template v-slot:append>
                      <q-btn icon="attach_money" flat round padding="none" @click="computeTax(props.row)">
                        <q-tooltip>
                          محاسبه مالیات
                        </q-tooltip>
                      </q-btn>
                    </template>
                  </q-field>
                  <q-chip v-if="!issueFactor" text-color="white" square color="teal-14" class="q-ml-xs">
                    {{ (props.row.SaleG_Tax) | toLoalString }}
                    ریال
                  </q-chip>
                </q-card-section>
                <q-card-section class="no-padding" v-if="props.row.Goods_Code!=='109991' && !noPrice">
                  <span class="text-subtitle2">تخفیف</span>
                  <q-field
                      v-if="issueFactor"
                      v-model="props.row.SaleG_Off"
                      mask="currency"
                      label-color="indigo"
                      autofocus
                      dir="ltr"
                      filled
                      dense
                      clearable
                      lazy-rules
                      :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'مبلغ خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'مبلغ خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
                    <template v-slot:control="{ id, floatingLabel, value, emitValue }">
                      <input :id="id" class="q-field__native text-right" :value="value"
                             @change="e => emitValue(e.target.value.replaceAll(',',''))"
                             v-money="moneyFormatForDirective"
                             v-show="floatingLabel">
                    </template>
                  </q-field>
                  <q-chip square color="red" v-if="!issueFactor" text-color="white"
                          :label="`${parseInt(props.row.SaleG_Off).toLocaleString()}`"/>
                </q-card-section>
              </q-card>
            </td>
          </q-tr>
        </template>
      </q-table>
    </q-card-section>
    <q-card-section v-if="issueFactor" align="center">
      <div class="row">
        <div class="col col-md-2 offset-5">
          <q-field
              v-if="issueFactor"
              v-model="totalOff"
              mask="currency"
              label="تخفیف کل"
              label-color="indigo"
              autofocus
              dir="ltr"
              filled
              dense
              clearable
              lazy-rules
              :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'تخفیف کل خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'تخفیف کل خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
            <template v-slot:control="{ id, floatingLabel, value, emitValue }">
              <input :id="id" class="q-field__native text-right" :value="value"
                     @change="e => emitValue(e.target.value.replaceAll(',',''))"
                     v-money="moneyFormatForDirective"
                     v-show="floatingLabel">
            </template>
          </q-field>
          <q-field
              v-if="issueFactor"
              v-model="transportCost"
              mask="currency"
              label="کرایه حمل بار"
              label-color="indigo"
              autofocus
              dir="ltr"
              filled
              dense
              clearable
              lazy-rules
              :rules="[
                      val => val.toString().replaceAll(',','') !== null && val.toString().replaceAll(',','') !== '' || 'تخفیف کل خرید را وارد نمایید',
                      val => parseInt(val.toString().replaceAll(',','')) >= 0   || 'تخفیف کل خرید عددی بزرگتر صفر می باشد، لطفا اصلاح نمایید'
                  ]">
            <template v-slot:control="{ id, floatingLabel, value, emitValue }">
              <input :id="id" class="q-field__native text-right" :value="value"
                     @change="e => emitValue(e.target.value.replaceAll(',',''))"
                     v-money="moneyFormatForDirective"
                     v-show="floatingLabel">
            </template>
          </q-field>
        </div>
      </div>
    </q-card-section>
    <q-card-actions align="center" v-if="issueFactor">
      <q-btn label="نهایی نمودن فاکتور" @click="issueFactorData" color="primary" icon="check"/>
      <q-btn flat label="انصراف" color="red" icon="cancel" @click="$emit('cancel-dialog')"/>
    </q-card-actions>


    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showProductDetails">
      <ProductDetail :product="selectedProductDetails"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import ProductDetail from "@/components/productInfo/ProductDetail.vue";

export default {
  name: "BuyFacDetails",
  components: {ProductDetail},
  props: {
    orderInfo: {
      type: Object
    },
    issueFactor: {
      type: Boolean,
      default: false
    },
    noPrice: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      storeList: [],
      selectedStoreId: undefined,
      factorHeader: undefined,
      transportCost: 0,
      moneyFormatForDirective: {
        decimal: '.',
        thousands: ',',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false
      },
      totalOff: 0,
      selectedProductDetails: [],
      showProductDetails: false,
      selectedCustomer: '',
      OrderDetailsList: [],
      pagination: {
        rowsPerPage: 10
      },
    }
  },
  methods: {
    ...mapActions({
      getDetails: 'Buys/getFactorDetails',
      getHeader: 'Buys/getFactorHeader',
      getCustomerInfo: 'Customers/get_customer_info',
      getProductInfo: 'Products/getProductInfo',
      generateFactor: 'Buys/upsertFactor',
      getStoreList: 'Products/getStoreList',
      deleteGoods: 'Buys/deleteFactorItem'
    }),
    deleteItem(itemInfo) {
      this.deleteGoods({
        BuyNum: this.orderInfo.Factor_Num,
        BuyKind: this.orderInfo.Buy_Kind,
        GoodsID: itemInfo.Goods_ID
      }).then(() => {
        const founded = this.OrderDetailsList.findIndex(item => item.Buy_Num === itemInfo.Goods_ID === itemInfo.Goods_ID)
        this.$delete(this.OrderDetailsList, founded)
      })
    },
    requireRole(val) {
      if (val === null || val === undefined || val === '') {
        return 'انتخاب الزامی است'
      }
    },
    computeTax(orderItemInfo) {
      orderItemInfo.SaleG_Tax = orderItemInfo.SaleG_TotalAll * 0.09
    },
    issueFactorData() {
      if (this.orderInfo.Factor_Buy_State === 0 && this.orderInfo.Buy_State === 1 && this.selectedStoreId === undefined) {
        this.$q.notify({
          message: 'انتخاب انبار الزامی است',
          type: 'negative',
          color: 'negative',
          position: 'top'
        })
      } else {
        const preventFinal = this.OrderDetailsList.filter(item => item.SaleG_Count === 0)
        if (preventFinal.length === 0) {
          const sendObject = {
            Factor_Num: this.orderInfo.Factor_Num,
            Buy_Num: this.orderInfo.Buy_Num,
            Buy_Kind: this.orderInfo.Buy_Kind,
            items: this.OrderDetailsList,
            transportCost: this.transportCost,
            totalOff: this.totalOff
          }
          if (this.selectedStoreId !== undefined) {
            sendObject.storeId = this.selectedStoreId.StorID
          } else {
            sendObject.storeId = -1
          }
          this.generateFactor(sendObject).then((res) => {
            if (res[0].BuyNum !== undefined) {
              this.$q.notify({
                type: 'positive',
                color: 'positive',
                position:'top',
                message: `فاکتور خرید به شماره ${res[0].BuyNum} ثبت گردید`
              })
              this.$emit('generated-factory', res)
            } else {
              this.$q.notify({
                type: 'negative',
                color: 'negative',
                position:'top',
                message: 'خطا در نهایی نمودن فاکتور'
              })
            }
          });
        } else {
          this.$q.notify({
            message: 'کالا نمی تواند دارای مقدار صفر باشد',
            type: 'negative',
            color: 'negative',
            position: 'top'
          })
        }
      }

    },
    showProductDetailsDialog(row) {
      this.getProductInfo(row.Goods_ID).then((res) => {
        this.selectedProductDetails = res[0];
        this.showProductDetails = true
      })
    },
  },
  created() {
    this.getHeader({Buy_Num: this.orderInfo.Factor_Num, Buy_Kind: this.orderInfo.Buy_Kind}).then((res) => {
      this.factorHeader = res[0]
      this.transportCost = this.factorHeader.Buy_Transfer
      this.totalOff = this.factorHeader.Buy_Off
      this.getDetails({Buy_Num: this.orderInfo.Factor_Num, Buy_Kind: this.orderInfo.Buy_Kind}).then((res) => {
        this.OrderDetailsList = res
        this.getStoreList().then((res) => {
          this.storeList = res
        })
      });
    })
  }
}
</script>

<style scoped>
.my-class > td:before {
  background: rgba(0, 0, 0, 0) !important;
}
</style>
